import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const stepOrder = {
  request: 1,
  verify: 2,
  mmc: 3,
  tutorial: 4,
  live_approval: 5,
};

const steps = [
  { key: "request", label: "Property Request", path: "/propertie-req-edit" },
  {
    key: "verify",
    label: "Document Verification",
    path: "/propertie-doc-edit",
    replace: true,
  },
  { key: "mmc", label: "MMC", path: "/propertie-mmc-edit" },
  { key: "tutorial", label: "Tutorial", path: "/properties-tutorial" },
  {
    key: "live_approval",
    label: "Live Approval",
    path: "/properties-live-approval",
  },
];

const CurrentStepCard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const current_position = location.state?.current_position;
  const max_position = location.state?.max_position;
  const id = location.state?.id;
  const owner_id = location.state?.owner_id;
  const tutorial_watched = location.state?.tutorial_watched;

  const reachedPosition =
    (stepOrder[max_position] ?? 0) > (stepOrder[current_position] ?? 0)
      ? max_position
      : current_position;

  const isCompleted = (step) => stepOrder[step] <= stepOrder[reachedPosition];
  const canNavigate = (step) => isCompleted(step);
  const isActive = (step) => current_position === step;

  const handleNavigation = (step) => {
    if (!canNavigate(step.key)) return;

    navigate(step.path, {
      state: {
        type: "edit",
        owner_id,
        id,
        current_position: step.key,
        max_position: reachedPosition,
        tutorial_watched,
      },
      ...(step.replace ? { replace: true } : {}),
    });
  };

  return (
    <div className="d-flex ac-jb">
      <div className="d-flex ac-jb">
        {steps.map((step, index) => (
          <React.Fragment key={step.key}>
            <p
              onClick={() => handleNavigation(step)}
              className={`f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 ${
                isActive(step.key) || isCompleted(step.key)
                  ? "prop-act-tab pointer"
                  : "prop-on-tab"
              }`}
            >
              {step.label}
            </p>
            {index < steps.length - 1 && (
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-line" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CurrentStepCard;
